import scrollIntoView from 'scroll-into-view-if-needed';

export default function(targetElement) {
    if (!targetElement) {
        return;
    }
    let hideHeader = false;
    if (window.matchMedia("only screen and (max-width: 767px)").matches) {
        hideHeader = true;
    }
    if (hideHeader && window.headroom) {
        window.headroom.unpin();
        window.headroom.freeze();
    }

    scrollIntoView(targetElement, { behavior: 'smooth', scrollMode: 'if-needed' });

    if (hideHeader && window.headroom) {
        window.headroom.unfreeze();
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/configurator/modules/scrollToElement.js